import React from "react";
import Latex from "react-latex-next";
import "./QuestionCard.css";

function QuestionCard({ question, onAdd, onPreview }) {
  const type = question.type?.toLowerCase?.() || "multiple-choice";
  const isShortAnswer = type === "short-answer";

  return (
    <div className="question-card">
      <div className="question-header">
        <div className="question-meta">
          <span>{question.subject || "No Subject"}</span> •{" "}
          <span>{question.topic || "No Topic"}</span> •{" "}
          <span style={{ color: "#f39c12" }}>
            {isShortAnswer ? "Short Answer" : "Multiple Choice"}
          </span>
        </div>
        <h3 className="question-title">
          <Latex>{question.question || "No question text provided"}</Latex>
        </h3>
      </div>

      {/* Short Answer Preview */}
      {isShortAnswer ? (
        <input
          className="short-answer-preview"
          type="text"
          placeholder="Student will type their answer here"
          disabled
        />
      ) : (
        // Multiple Choice Options
        <div className="options-list">
          {(question.options || []).map((opt, i) => (
            <div key={i} className="option">
              <Latex>{opt}</Latex>
            </div>
          ))}
        </div>
      )}

      <div className="question-actions">
        <button onClick={onPreview}>👁 Preview</button>
        <button onClick={onAdd}>➕ Add to Assignment</button>
      </div>
    </div>
  );
}

export default QuestionCard;
